import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router';
import { getTokenFromParams } from '@helpers/utils';
import { Modal, Icon } from 'fpay-ui';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import * as ROUTES from '@constants/routes';
import MoneyResume from '@components/MoneyResume';
import { showError } from '@store/logged/actions';
import BankAccount from '@components/BankAccount';
import { succesMail } from '@constants/errorObjects';
import { useFundsOut } from '@hooks/useFundsOut';
import { useTranslation } from 'react-i18next';
import AutomaticFundsTranfer from '@components/AutomaticFundsTranfer';
import { useAndes, useBlockings, useAuth } from '@hooks';
import { isAllowed } from '@helpers/auth';
import { getEnv } from '@config';
import BlockScreen from '@components/BlockScreen';
import styled from 'styled-components';
import SkeletonFoundsOut from './index.skeleton';

export const FoundsOut = () => {
  const { isSkeleton } = useSelector((state) => state.common) || true;
  const { merchant, isSeller } = useAuth();
  const { enabledBlockingFundsOutForAll } = getEnv();
  const { bankAccount } = useFundsOut();
  const { getBlockings, blockings, blockingDetails } = useBlockings();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const viewWithdrawMoney = isAllowed('WITHDRAW_DO');
  const viewBankAccount = isAllowed('WITHDRAW_CREATE_BANK_ACCOUNT');
  const viewAdvancementButton = isAllowed('EXECUTE_ADVANCEMENT');

  const [showModal, setShowModal] = useState(false);
  const isBlocked = (action) => blockings.includes(action);
  const shouldShowAdvancementButton = () =>
    isSeller() && viewAdvancementButton && !isBlocked('ADVANCEMENT');
  const { breakpoint } = useBreakpoints();
  const width = breakpoint === 'xs' ? '343px' : '504px';
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const blockingsAllowed =
    isAllowed('FINANCING_BLOCKINGS') && (enabledBlockingFundsOutForAll === 'true' || isSeller());

  /** Se agrega null en useAndes para cortar request innecesarias */
  const { availableIncome, getBalances, settledIncome } = useAndes(null, undefined, false);

  useEffect(() => {
    getBalances();
    if (viewBankAccount && !bankAccount) {
      setShowModal(true);
    }
    if (getTokenFromParams(history.location) === 'success')
      dispatch(showError(succesMail(t('commerceData.bankAccount.addAccountSuccess'))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (blockingsAllowed) {
      getBlockings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchant, blockingsAllowed]);

  const handleAddAccount = () => {
    history.push(ROUTES.ADD_BANK_ACCOUNT);
  };

  const isBlock = blockingsAllowed && blockings.includes('FUNDS_OUT');

  const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 30px;
    padding-left: 24px;
  `;
  const HeaderChildren = () => (
    <Header>
      <Icon icon="icon-modal-money" width="48px" height="auto" color="#fff2d100" />
    </Header>
  );

  if (isSkeleton) {
    return (
      <SkeletonFoundsOut
        viewBankAccount={viewBankAccount}
        viewWithdrawMoney={viewWithdrawMoney}
        viewAdvancementButton={shouldShowAdvancementButton()}
      />
    );
  }

  return isBlock ? (
    <BlockScreen blockingDetails={blockingDetails.find((detail) => detail.name === 'FUNDS_OUT')} />
  ) : (
    <Grid container justify="center" alignItems="center">
      <MoneyResume
        bankAccount={bankAccount}
        availableIncome={availableIncome}
        settledIncome={settledIncome}
        viewWithdrawMoney={viewWithdrawMoney}
        htmlIdButton="withdraw-money-funds-out"
        viewAdvancementButton={shouldShowAdvancementButton()}
      />
      <Grid container justify="center">
        <AutomaticFundsTranfer bankAccount={bankAccount} />
      </Grid>
      <Grid container justify="center">
        <BankAccount htmlIdButtonNotAddedAccount="add-bank-account-funds-out" />
      </Grid>
      {showModal && (
        <Modal
          fClose={handleCloseModal}
          showCloseButton
          header
          width={width}
          height="auto"
          paddingLeft="0px"
          paddingRight="0px"
          paddingBotton=""
          htmlIdBackground="idBackground"
          htmlIdClose="idClose"
          headerChildren={HeaderChildren()}
          modalCloseIcon="cross-n2"
          headerBgColor="#FFF2D1"
          modalTitle={t('commerceData.bankAccount.modalTitle')}
          modalDescription={t('commerceData.bankAccount.modalDescription')}
          modalSecondaryButton={t('commerceData.bankAccount.modalSecondaryButton')}
          modalButton={t('commerceData.bankAccount.modalButton')}
          handleButtonClick={handleAddAccount}
          handleSecondaryButtonClick={handleCloseModal}
          buttonBorderRadius="40px"
          buttonSecondaryBorderRadius="40px"
          buttonMargin="15px 24px"
          buttonSecondaryMargin="15px 24px"
          buttonColor="gbrand500"
          buttonSecondaryColor="black"
          buttonType="button"
          buttonSecondaryType="outlined"
          buttonSize="mediumBold"
          buttonSecondarySize="mediumBold"
          titlePaddingBottom="40px"
        />
      )}
    </Grid>
  );
};

export default FoundsOut;
